import { SparePart } from "src/app/api/spareParts/sparePart";
import { SparePartsInPackage } from "src/app/api/spareParts/sparePartsInPackage";

export class SparePartViewModel {
    Id?: number;
    PartNumber?: string;
    Description?: string;
    TechData?: string;
    Quantity?: number;

    public static CreateForPackage(sparePartInPackage: SparePartsInPackage) {
        return {
            Id: sparePartInPackage.SparePart.Id,
            PartNumber: sparePartInPackage.SparePart.PartNumber,
            Description: sparePartInPackage.SparePart.Description,
            TechData: sparePartInPackage.SparePart.TechData,
            Quantity: sparePartInPackage.Quantity
        } as SparePartViewModel;
    }
    public static CreateForSinglePart(sparePart: SparePart) {
        return {
            Id: sparePart.Id,
            PartNumber: sparePart.PartNumber,
            Description: sparePart.Description,
            TechData: sparePart.TechData
        } as SparePartViewModel;
    }
}